export default "__VITE_ASSET__Bl_mrpv1__"